import { pgMessageBox } from '../../message-box/index'

/**
 * 仅提示方法
 * @param {*} params
 * @param {*} actions
 * @returns
 */
export async function confirmTip(params) {
  const confirmOption = {
    confirmText: '确认',
    message: '确认操作？',
    ...params.property,
  }

  if (params.parameter?.hideConfirm) {
    return Promise.resolve({ type: 'confirm' })
  }

  const { done, type } = await new Promise((resolve) => {
    pgMessageBox({
      ...confirmOption,
      beforeClose: (done, type) => {
        resolve({ done, type })
      },
    })
  })

  done?.()
  if (type) {
    return Promise.resolve({ type }) // type = secoundConfirm/confirm
  } else {
    return Promise.reject()
  }
}
